@if (cardInfo(); as cardInfo) {
  @if (cardInfo.isReady) {
    <mat-card>
      <mat-card-header [style.margin-left]="!showAvatar ? (AVATAR_WIDTH + 16).toString() + 'px' : null">
        @if (cardInfo.isUpdatedRecordChange) {
          <div matCardAvatar>
            <glxy-avatar
              [width]="AVATAR_WIDTH"
              [icon]="icon()"
              backgroundColor="var(--primary-background-color)"
              textColor="#9E9E9E"
            ></glxy-avatar>
          </div>
        }
        @if (!cardInfo.isUpdatedRecordChange) {
          <div matCardAvatar></div>
        }
        <mat-card-title>
          <span class="title">{{ cardInfo.headerText }}</span>
        </mat-card-title>
        <mat-card-subtitle>
          @if (cardInfo.effectiveDate !== null) {
            <p class="effective-date">
              {{ cardInfo.effectiveDate | date: dateFormat }}
            </p>
          }
        </mat-card-subtitle>
      </mat-card-header>
      <mat-card-content [style.margin-left]="(AVATAR_WIDTH + 18).toString() + 'px'">
        <span class="content">{{ cardInfo.contentText }}</span>
      </mat-card-content>
    </mat-card>
  }
}
